<template>
  <v-skeleton-loader
    :loading="$store.getters['claimsStatuses/loading']"
    type="list-item-two-line"
  >
    <v-select
      v-model="selected"
      :dense="dense"
      :menu-props="{maxHeight: 500}"
      :disabled="disabled"
      :items="items"
      item-text="title"
      item-value="digitValue"
      label="Статус заявки"
      :item-color="$store.getters['settings/dark'] ? 'white' : 'black'"
      :error-messages="errorMessages"
      @input="onSelectedChanged"
      @blur="onBlur"
    />
  </v-skeleton-loader>
</template>

<script>
export default {
  props: ['value', 'disabled', 'errorMessages', 'dense'],

  data: () => ({
    selected: null
  }),

  computed: {
    items: function () {
      const statuses = this.$store.getters['claimsStatuses/items'] || [];
      
      // Используем null или -1 для "Любой", а не 0!
      return [
        { digitValue: null, title: '[ Любой ]' },  // или -1
        ...statuses
      ];
    }
  },

  watch: {
    value: function (val) {
      this.selected = val
    }
  },

  created () {
    this.selected = this.value
  },

  methods: {
    onSelectedChanged (val) {
      this.$emit('input', val)
    },
    onBlur (val) {
      this.$emit('blur', val)
    }
  }
}
</script>